import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import PricingCalendar from "@/pages/admin/PricingCalendar";
import Leads from "@/pages/admin/Leads";
import Bookings from "@/pages/admin/Bookings";
import Payments from "@/pages/admin/Payments";
import Campaigns from "@/pages/admin/Campaigns";
import Knowledge from "@/pages/admin/Knowledge";
import Studio from "@/pages/admin/Studio";
import Broadcast from "@/pages/admin/Broadcast";
import ChatTest from "@/pages/admin/ChatTest";
import SettingsPage from "@/pages/admin/SettingsPage";
import RequireAuth from "@/components/RequireAuth";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
          <Route index element={<Overview />} />
          <Route path="pricing" element={<PricingCalendar />} />
          <Route path="leads" element={<Leads />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="payments" element={<Payments />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="knowledge" element={<Knowledge />} />
          <Route path="studio" element={<Studio />} />
          <Route path="broadcast" element={<Broadcast />} />
          <Route path="chat" element={<ChatTest />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
